import { Branding, DisabledPrompt, Link } from "bcms-react";
import React from "react";

import { ImageAsset } from "res";
import "./styles.css";

import WidgetContainer from "components/shared/containers/WidgetContainer";
import WidgetView from "components/shared/views/WidgetView";
import { PrimaryButton } from "components/ui";


/**
 * @function CreditScoreWidget
 * @param {STRING} date - Sets the updated date. 
 * @param {STRING} rating - Sets the rating number. 
 * @param {STRING} alertNum - Sets the number of alerts. 
 * @param {STRING} loan - Sets the recommended for you text. 
 * @param {STRING} dialDataPoint - Sets the data point for the credit score graph. 
 * @param {STRING} scoreDataPoint - Sets the data point for the score. 
 * @param {STRING} updatedDataPoint - Sets the data point for the updated text. 
 * @param {STRING} alertsDataPoint - Sets the sets the data point for the number of alerts. 
 * @param {STRING} fullReportDataPoint - Sets the data point for the full report button. 
 * @param {STRING} scoreChangeNum - Sets the number for the score change. 
 * @param {STRING} creditUsageNum - Sets the sets the number for the credit usage. 
 * @returns {React.Component}
 * @description This is a widget that shows a summary of the Credit Score page, which pulls in CS21.
 */
export default function CreditScoreWidget(props) {
  const date = props.date ?? "Month DD, YYYY";
  const rating = props.rating ?? "Good";
  const alertNum = props.alertNum ?? "9+"
  const loan = props.loan ?? "Rewards Credit Card";

  const dialDataPoint = props.dialDataPoint ?? "";
  const scoreDataPoint = props.scoreDataPoint ?? "";
  const updatedDataPoint = props.updatedDataPoint ?? "";
  const alertsDataPoint = props.alertsDataPoint ?? "";
  const fullReportDataPoint = props.fullReportDataPoint ?? "";
  const ratingDataPoint = props.ratingDataPoint ? { "data-point": props.ratingDataPoint } : {};

  const scoreChangeNum = props.scoreChangeNum ?? "0";
  const creditUsageNum = props.creditUsageNum ?? "0";

  return(
    <WidgetContainer className="credit-score-widget">
      <WidgetView text="Credit Score" data-point="Credit_Score_Widget"> 
        <div className="credit-report-container flex-container flex-vertical">
          
          <div className="flex-height text-center">
            <div className="credit-score-graph-container">
              <div className="credit-score-image-container text-center">
                <ImageAsset id="CreditScoreImage" className="credit-score-image" data-point={dialDataPoint} />
                <span className="credit-score" data-point={scoreDataPoint}>750</span>
                <div className="credit-score-indicator"></div>
                <div className="flex-container flex-horizontal align-center credit-range">
                <span className="flex-width text-left">300</span>
                <span className="flex-width text-right">850</span>
              </div>
              </div>
            </div>
            <p><b { ...ratingDataPoint }>Rating: {rating}</b></p>
            <p className="sub-text">Updated: <span data-point={updatedDataPoint}>{date}</span></p>
          </div>
          <div className="flex-height flex-container flex-horizontal align-center values-container">
            <div className="score-change-section flex-width flex-container flex-vertical align-center divider">
              <div className="score-change-container text-container flex-container flex-horizontal align-center">
                <span data-point="Score_Change_Num">{ scoreChangeNum }</span>
              </div>
              <div className="score-change-text label-container text-center">
                <span data-point="Score_Change_Label">Score Change</span>
              </div>
            </div>
            <div className="credit-usage-section flex-width flex-container flex-vertical align-center divider">
              <div className="credit-usage-container flex-container flex-horizontal align-center text-container">
                <span className="flex-width icon">&#x25BC;</span>
                <span className="flex-width" data-point="Credit_Usage_Num">{ creditUsageNum }%</span>
              </div>
              <div className="credit-usage-text label-container text-center">
                <span data-point="Credit_Usage_Label">Credit Usage</span>
              </div>
            </div>
            <div className="alerts-section flex-width flex-container flex-vertical text-center align-center">
              <div className="alert-container text-center text-container">
                <span data-point="Alerts_Num">{alertNum}</span>
              </div>
              <div className="alert-text label-container text-center">
                <span data-point={alertsDataPoint}>New Alerts</span>
              </div>
            </div>
          </div>
          <div className="flex-height button-container text-center">
          <Branding id="cs21_courseID_abi22" exp={val => val === null}>
            <DisabledPrompt>
              <PrimaryButton text="Show Full Report" data-point={fullReportDataPoint} />
            </DisabledPrompt>
            </Branding>
            <Branding id="cs21_courseID_abi22" exp={val => val !== null}>   
            <Link to="/creditScore">
            <PrimaryButton text="Show Full Report" data-point={fullReportDataPoint} /> 
            </Link>                              
            </Branding> 
          </div>
          <div className="flex-height recommended-container flex-container flex-vertical text-center">
            <div className="flex-height">
              <span className="section-label">Recommended for you</span>
            </div>
            <div className="flex-height">
              <span className="sub-text">{loan}</span>
            </div>
            <div className="flex-height">
              <DisabledPrompt>
                <Link>Learn more</Link>
              </DisabledPrompt>
              <div className="indicator-container flex-container flex-horizontal all-center">
                <DisabledPrompt>
                  <div className="circle-indicator selected clickable"></div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="circle-indicator clickable"></div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="circle-indicator clickable"></div>
                </DisabledPrompt>
              </div>
            </div>
          </div>
          
        </div>
      </WidgetView>
    </WidgetContainer>
  );
}